import { MaterialRequestsTable } from "./MaterialRequestsTable";
import { InventoryStats } from "./InventoryStats";
import { FilterSection } from "../../../components/ui";
import { Plus, RefreshCcw } from "lucide-react";

export const RequestsView = ({
  search,
  setSearch,
  filters,
  setFilters,
  filteredRequests,
  projects,
  user,
  setSelReq,
  setDispatchReq,
  handleDeliver,
  ownerAction,
  onAddItems,
  onCreateRequest
}) => {
  const customerOptions = Array.from(new Set(
    (projects || []).map(p => p.customerName || p.name).filter(Boolean)
  )).sort();

  return (
    <div className="space-y-6 animate-in fade-in duration-500">
      <InventoryStats
        activeTab={filteredRequests?.[0]?.serviceType || "solar"}
        viewMode="requests"
        subTab="items"
        isExpanded={false}
        setIsExpanded={() => {}}
        requests={filteredRequests}
        inventory={[]}
        sales={[]}
        returns={[]}
        purchaseReturns={[]}
      />
{/* updated Halimunnisa 2026-06-08 */}
{/* added onCreateRequest prop to handle the creation of new material requests when the "Add Request" button is clicked. This allows users to easily initiate new requests directly from the RequestsView component. The button is styled with a plus icon and is positioned next to the refresh button for better accessibility. */} 
      <FilterSection
        search={search}
        setSearch={setSearch}
        filters={filters || {}}
        setFilters={(key, val) => setFilters && setFilters(prev => ({ ...prev, [key]: val }))}
        statusOptions={[
          { value: "pending", label: "Pending Approval" },
          { value: "approved", label: "Approved" },
          { value: "dispatched", label: "Dispatched" },
          { value: "delivered", label: "Delivered" },
          { value: "rejected", label: "Rejected" },
        ]}
        statusPlaceholder="All Request Stages"
        customerOptions={customerOptions}
        customerPlaceholder="All Projects/Customers"
        onExport={() => {
          // Export functionality placeholder
        }}
      />

      <MaterialRequestsTable
        activeTab={null}
        materialRequests={filteredRequests}
        projects={projects}
        user={user}
        onViewRequest={setSelReq}
        onDeliver={setDispatchReq}
        onMarkAsDelivered={handleDeliver}
        onOwnerAction={ownerAction}
        onAddItems={onAddItems}
        isInventoryModule={true}
      />
    </div>
  );
};

